import "./Login.scss";
import { redirectToLogin } from "../../features/request";

export default function Login() {
  return (
    <div className="login-page">
      <div className="login-card">
        <h1 className="login-title">
          Для доступа в сервис нужно пройти авторизацию
        </h1>
        <h2 className="login-subtitle">
          Нажмите кнопку чтобы авторизоваться
        </h2>
        <button className="btn-primary" onClick={redirectToLogin}>
          Авторизоваться
        </button>
      </div>
    </div>
  );
}